import { Controller, useFormContext } from 'react-hook-form';
import { Grid, Paper } from '@mui/material';
import { LabeledTextField } from '@components';
import { LabeledMultiAutocompleteField } from '@common/ui/LabeledMultiAutocompleteField/LabeledMultiAutocompleteField';

const urlPattern = /^(ftp|http|https):\/\/.*$/;

function OAuthFields() {
  const { control } = useFormContext();

  return (
    <Paper variant="contained">
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Controller
            control={control}
            name="authentication_config.oauth.client_id"
            rules={{ required: 'Client ID is required' }}
            render={({ field, fieldState: { error } }) => (
              <LabeledTextField
                label="Client ID"
                error={!!error}
                helperText={error?.message}
                placeholder="client_id"
                {...field}
              />
            )}
          />
        </Grid>

        <Grid item xs={6}>
          <Controller
            control={control}
            name="authentication_config.oauth.client_secret"
            rules={{ required: 'Client Secret is required' }}
            render={({ field, fieldState: { error } }) => (
              <LabeledTextField
                label="Client Secret"
                type="password"
                placeholder="client_secret"
                error={!!error}
                helperText={error?.message}
                {...field}
              />
            )}
          />
        </Grid>

        <Grid item xs={6}>
          <Controller
            control={control}
            name="authentication_config.oauth.token_endpoint_url"
            rules={{
              required: 'Token Endpoint URL is required',
              pattern: {
                value: urlPattern,
                message: 'Invalid URL',
              },
            }}
            render={({ field, fieldState: { error } }) => (
              <LabeledTextField
                label="Token Endpoint URL"
                error={!!error}
                helperText={error?.message}
                placeholder="https://example.com/oauth/token"
                {...field}
              />
            )}
          />
        </Grid>

        <Grid item xs={6}>
          <Controller
            control={control}
            name="authentication_config.oauth.scopes"
            render={({ field, fieldState: { error } }) => (
              <LabeledMultiAutocompleteField
                label="Scopes"
                value={field.value}
                options={[]}
                placeholder="Type and press Enter"
                onChange={(value) => field.onChange(value)}
                error={!!error}
                helperText={error?.message}
              />
            )}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}

export default OAuthFields;
